import { ref } from "vue";
import useApi from "@/services/useApi";
import { useStore } from "vuex";

export default function useActivationTelegram() {
    const { api, reactiveHeaders } = useApi();
    const store = useStore();

    const activationStatus = ref("");
    const payloadLinkActivationTelegram = ref({}); // {description, status, ?data: {link}}
    const statusNumberActivation = ref({});
    const serverId = ref("");
    const numberKey = ref("");
    const twoFactorAuth = ref("");

    const initiateActivationTelegram = async (number) => {
        const strNumber = number ? String(number) : "";

        await api
            .post(
                "/api/activation/telegram",
                { number: strNumber },
                { headers: reactiveHeaders.value }
            )
            .then((res) => {
                numberKey.value = res.data.data.number_key;
                activationStatus.value = "generationCode";
            })
            .catch((error) => {
                console.error(
                    "Error initiateActivationTelegram",
                    error.message
                );
                activationStatus.value = "oops";
            });
    };

    const getLinkActivationTelegram = (numberId) => {
        const strNumberId = numberId ? String(numberId) : "";
        let result = "";
        return api
            .post(
                "/api/activation/telegram/link",
                { number_id: strNumberId },
                { headers: reactiveHeaders.value }
            )
            .then((response) => {
                result = response.data;
                if (result?.data?.link) {
                    store.commit("activation/SET_QR_LINK", result.data.link);
                }
                serverId.value = result.data?.server_id;
                store.commit("activation/SET_SERVER_ID", serverId.value);
                payloadLinkActivationTelegram.value = "scanCode";
                return result;
            })
            .catch((error) => {
                const result = error.response?.data;
                const desc = result?.description;
                switch (desc) {
                    case "Pending link generation":
                        payloadLinkActivationTelegram.value = "generationCode";
                        break;
                    case "Number activated":
                        store.commit(
                            "activation/SET_NUMBER",
                            result.data.number
                        );
                        payloadLinkActivationTelegram.value = "activated";
                        break;
                    case "Number requires activation":
                        payloadLinkActivationTelegram.value = "timeOver";
                        break;
                    case "Something went wrong":
                    default:
                        payloadLinkActivationTelegram.value = "oops";
                        break;
                }
                return result;
            });
    };
    const getStatusActivationTelegram = async (numberId, serverId) => {
        const strNumberId = numberId ? String(numberId) : "";
        const strServerId = serverId ? String(serverId) : "";

        await api
            .post(
                "/api/activation/telegram/status",
                {
                    number_id: strNumberId,
                    server_id: strServerId,
                },
                { headers: reactiveHeaders.value }
            )
            .then((response) => {
                statusNumberActivation.value = "successActivation";
                store.commit('activation/SET_NUMBER', response.data.data.number) // check
                return response.data;
            })
            .catch((error) => {
                const descResponse = error.response.data.description;
                const separateArray = descResponse.split("|");
                const description = separateArray[0]?.trim();
                const number = separateArray[1]?.trim();
                let textDialog;
                switch (description) {
                    case "Invalid number error":
                        textDialog = "invalidNumberError";
                    case "Existing number error":
                        textDialog = "existsNumberError";
                        break;
                    case "Already activated error":
                        textDialog = "alreadyActivatedError";
                        break;
                    case "Requires activation":
                        statusNumberActivation.value = "timeOver";
                        break;
                    case "Pending number activation":
                        break;
                    case "Two-factor authentication":
                    case "Failed two factor password":
                        statusNumberActivation.value = "twoFactorAuth";
                        break;
                    case "Something went wrong":
                    default:
                        statusNumberActivation.value = "oops";
                        break;
                }

                if (textDialog) {
                    store.commit("activation/SET_NUMBER", number);

                    const params = {
                        number,
                        info: textDialog || null,
                    };

                    store.commit("openDialog", {
                        name: "InformationDialog",
                        params,
                    });
                    statusNumberActivation.value = "errorActivation";
                }
            });
    };
    const postTwoFactorAuth = (payload) => {
        return api
            .post(
                "/api/activation/telegram/two-factor",
                payload, //{server_id, password}
                { headers: reactiveHeaders.value }
            )
            .then((response) => {
                twoFactorAuth.value = response.data.description;
            })
            .catch((error) => {
                console.error(error);
                twoFactorAuth.value = "oops";
            });
    };

    return {
        initiateActivationTelegram,
        activationStatus,
        numberKey,
        getLinkActivationTelegram,
        payloadLinkActivationTelegram,
        serverId,
        getStatusActivationTelegram,
        statusNumberActivation,
        postTwoFactorAuth,
        twoFactorAuth,
    };
}
